function initProductGallery() {
  if (typeof Splide === 'undefined') return;

  var elements = document.querySelectorAll('.js-product-gallery-splide');
  elements.forEach(function (el) {
    if (el.classList.contains('is-initialized')) return;

    var slides = el.querySelectorAll('.product-gallery__slide');
    if (slides.length === 0) return;

    var gallery = el.closest('.product-gallery');
    var mediaWrapper = el.closest('.product-media-wrapper');

    var mapEl = mediaWrapper ? mediaWrapper.querySelector('[data-product-gallery-variant-media]') : null;
    var variantMediaMap = {};
    if (mapEl) {
      try {
        variantMediaMap = JSON.parse(mapEl.textContent) || {};
      } catch (e) {
        variantMediaMap = {};
      }
    }

    function slideIndexForVariant(variantId) {
      var mediaId = variantMediaMap[variantId];
      if (!mediaId) return -1;

      var targetIndex = -1;
      slides.forEach(function (slide, index) {
        if (slide.dataset.mediaId === String(mediaId)) targetIndex = index;
      });
      return targetIndex;
    }

    function getSelectedVariantInput() {
      var productForm = document.querySelector('.product-form-snippet form');
      if (!productForm) return null;
      var hasRadios = productForm.querySelectorAll('input[type="radio"][name="id"]').length > 0;
      return hasRadios
        ? productForm.querySelector('input[type="radio"][name="id"]:checked')
        : productForm.querySelector('input[name="id"]');
    }

    var initialInput = getSelectedVariantInput();
    var initialIndex = initialInput ? slideIndexForVariant(initialInput.value) : -1;

    var slider = new Splide(el, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: 0,
      pagination: false,
      arrows: false,
      drag: slides.length > 1,
      speed: 1000,
      rewind: false,
      start: initialIndex > 0 ? initialIndex : 0
    });

    var prevBtn = el.querySelector('.js-product-gallery-prev');
    var nextBtn = el.querySelector('.js-product-gallery-next');
    var thumbsContainer = gallery ? gallery.querySelector('.js-product-gallery-thumbs') : null;
    var thumbs = thumbsContainer ? thumbsContainer.querySelectorAll('.js-product-gallery-thumb') : [];

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        slider.go('<');
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        slider.go('>');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.dataset.index, 10);
        if (!isNaN(index)) slider.go(index);
      });
    });

    function syncSlideVideos() {
      slides.forEach(function (slide, index) {
        slide.querySelectorAll('video').forEach(function (video) {
          if (index !== slider.index) {
            if (!video.paused) video.pause();
            return;
          }

          var host = video.closest('video-media');
          if (host && host.loadSources) host.loadSources();

          if (video.paused && video.muted && video.dataset.userPaused !== 'true') {
            video.play().catch(function () {});
          }
        });
      });
    }

    function scrollActiveThumbIntoView(thumb) {
      if (!thumbsContainer) return;

      var hasOverflow =
        thumbsContainer.scrollWidth > thumbsContainer.clientWidth ||
        thumbsContainer.scrollHeight > thumbsContainer.clientHeight;
      if (!hasOverflow) return;

      /* Rect-based so it works whatever the container's offset parent is */
      var containerRect = thumbsContainer.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();

      var targetLeft = thumbsContainer.scrollLeft
        + (thumbRect.left - containerRect.left)
        - (containerRect.width - thumbRect.width) / 2;
      var targetTop = thumbsContainer.scrollTop
        + (thumbRect.top - containerRect.top)
        - (containerRect.height - thumbRect.height) / 2;

      thumbsContainer.scrollTo({ left: targetLeft, top: targetTop, behavior: 'smooth' });
    }

    function syncControls() {
      var end = slider.Components.Controller.getEnd();
      if (!isFinite(end) || end < 0) end = 0;

      var index = Math.min(Math.max(slider.index, 0), end);

      thumbs.forEach(function (thumb) {
        var isActive = parseInt(thumb.dataset.index, 10) === index;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) scrollActiveThumbIntoView(thumb);
      });

      if (prevBtn) prevBtn.classList.toggle('is-disabled', index <= 0);
      if (nextBtn) nextBtn.classList.toggle('is-disabled', index >= end);

      syncSlideVideos();
    }

    slider.on('mounted move moved updated refresh resized', syncControls);
    slider.mount();
    el.classList.add('is-initialized');

    /* ── Variant featured media → jump slider to matching slide ── */
    if (mapEl) {
      document.querySelectorAll('.product-form-snippet form input[name="id"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var targetIndex = slideIndexForVariant(radio.value);
          if (targetIndex < 0 || targetIndex === slider.index) return;

          /* Variant changes jump straight to the matching media - the slide
             animation belongs to browsing the gallery, not to picking a shade.
             Splide only animates when `speed >= 1`; below that it takes an
             internal `jump()` path, so temporarily zeroing the speed swaps the
             slide instantly while still emitting `moved` for syncControls. */
          var gallerySpeed = slider.options.speed;
          slider.options = { speed: 0 };
          slider.go(targetIndex);
          slider.options = { speed: gallerySpeed };
        });
      });
    }
  });
}

function alignVariantTextListWidths() {
  document.querySelectorAll('.variant-text-list').forEach(function (list) {
    var items = list.querySelectorAll('.variant-text-item');
    if (!items.length) return;

    items.forEach(function (item) {
      item.style.width = 'auto';
    });

    var maxW = 0;
    items.forEach(function (item) {
      var label = item.querySelector('.variant-text-label');
      var w = label ? label.getBoundingClientRect().width : item.getBoundingClientRect().width;
      if (w > maxW) maxW = w;
    });

    if (maxW > 0) {
      var itemWidth = Math.ceil(maxW) + 'px';
      items.forEach(function (item) {
        item.style.width = itemWidth;
      });
    }
  });
}

function initProductForm() {
  alignVariantTextListWidths();
  const productForm = document.querySelector('.product-form-snippet form');
  if (!productForm || productForm.dataset.initialized === 'true') return;
  productForm.dataset.initialized = 'true';

  const variantRadios = productForm.querySelectorAll('input[name="id"]');
  const addToCartBtn = productForm.querySelector('[type="submit"]');
  const qtyInput = productForm.querySelector('#quantity');
  const qtyMinus = productForm.querySelector('.qty-minus');
  const qtyPlus = productForm.querySelector('.qty-plus');
  const labelNameEl = productForm.querySelector('.js-selected-variant-name');
  const fallbackVariantTitle = labelNameEl
    ? labelNameEl.dataset.defaultTitle || labelNameEl.textContent.trim()
    : '';
  let hoverResetFrame = null;

  function setVariantLabel(title) {
    if (!labelNameEl) return;
    const text = title || fallbackVariantTitle;
    if (!text || labelNameEl.textContent === text) return;
    labelNameEl.textContent = text;
  }

  function setBtnText(btn, text) {
    if (!btn) return;
    const textSpan = btn.querySelector('.js-add-to-cart-text');
    if (textSpan) {
      textSpan.textContent = text;
    } else {
      btn.textContent = text;
    }
    if (btn.tagName === 'INPUT') btn.value = text;
  }

  function updateURL(variantId) {
    if (!variantId || typeof window.history.replaceState !== 'function') return;
    const url = new URL(window.location.href);
    if (url.searchParams.get('variant') === String(variantId)) return;
    url.searchParams.set('variant', variantId);
    window.history.replaceState({ path: url.href }, '', url.href);
  }

  function updateVariantState(radio, isUserInteraction = true) {
    if (!radio) return;

    if (isUserInteraction && radio.value) {
      updateURL(radio.value);
    }

    const isAvailable = radio.dataset.available === 'true';
    const variantTitle = radio.dataset.variantTitle || radio.getAttribute('aria-label') || '';

    setVariantLabel(variantTitle);

    const price = radio.dataset.price;
    const comparePrice = radio.dataset.comparePrice;
    const priceWrapper = document.querySelector('.section-product .product-price');
    if (priceWrapper && price) {
      const currentPriceEl = priceWrapper.querySelector('.current-price');
      const comparePriceEl = priceWrapper.querySelector('.compare-price');

      if (currentPriceEl) currentPriceEl.textContent = price;

      if (comparePrice) {
        priceWrapper.classList.add('is-sale');
        if (comparePriceEl) {
          comparePriceEl.textContent = comparePrice;
          comparePriceEl.style.display = '';
        }
      } else {
        priceWrapper.classList.remove('is-sale');
        if (comparePriceEl) {
          comparePriceEl.textContent = '';
          comparePriceEl.style.display = 'none';
        }
      }
    }

    const storeAvailabilityEl = document.querySelector('.section-product [data-store-availability]');
    if (storeAvailabilityEl && radio.dataset.storeAvailable) {
      storeAvailabilityEl.dataset.storeAvailable = radio.dataset.storeAvailable;
    }

    productForm.querySelectorAll('.swatch-item, .variant-text-item').forEach(el => {
      el.classList.remove('active');
    });
    const parentItem = radio.closest('.swatch-item, .variant-text-item');
    if (parentItem) parentItem.classList.add('active');

    const isComingSoon = addToCartBtn && addToCartBtn.dataset.comingSoon === 'true';
    const notifyEnabled = addToCartBtn && addToCartBtn.dataset.notifyEnabled === 'true';

    if (addToCartBtn) {
      const showNotify = notifyEnabled && (isComingSoon || !isAvailable);
      addToCartBtn.classList.toggle('js-klaviyo-bis', showNotify);
      addToCartBtn.classList.toggle('button--notify', showNotify && !isComingSoon);

      if (isComingSoon) {
        addToCartBtn.disabled = false;
        setBtnText(addToCartBtn, addToCartBtn.dataset.addText || 'COMING SOON - GET NOTIFIED');
      } else if (!isAvailable) {
        addToCartBtn.disabled = !showNotify;
        setBtnText(addToCartBtn, addToCartBtn.dataset.soldoutText || 'Sold out');
      } else {
        addToCartBtn.disabled = addToCartBtn.dataset.archiveLocked === 'true';
        setBtnText(addToCartBtn, addToCartBtn.dataset.addText || 'Add to cart');
      }
    }

    if (typeof window.syncStickyAddToCartVariant === 'function') {
      window.syncStickyAddToCartVariant(radio.value);
    }
  }

  variantRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      const errorMsg = productForm.querySelector('.js-size-error-message');
      if (errorMsg) errorMsg.style.display = 'none';
      updateVariantState(radio, true);
    });
  });

  const checkedRadio = productForm.querySelector('input[type="radio"][name="id"]:checked');
  const singleHiddenInput = productForm.querySelectorAll('input[type="radio"][name="id"]').length === 0 ? productForm.querySelector('input[name="id"]') : null;
  const initialVariant = checkedRadio || singleHiddenInput;
  if (initialVariant) updateVariantState(initialVariant, false);

  // Hover effect over swatch/variant items -> adjust textual name to hovered one
  const swatchItems = productForm.querySelectorAll('.swatch-item, .variant-text-item');
  swatchItems.forEach(item => {
    const radio = item.querySelector('input[name="id"]');
    if (!radio) return;
    const variantTitle = radio.dataset.variantTitle || radio.getAttribute('aria-label') || '';

    item.addEventListener('mouseenter', () => {
      if (hoverResetFrame) {
        cancelAnimationFrame(hoverResetFrame);
        hoverResetFrame = null;
      }
      setVariantLabel(variantTitle);
    });

    item.addEventListener('mouseleave', () => {
      if (hoverResetFrame) cancelAnimationFrame(hoverResetFrame);
      hoverResetFrame = requestAnimationFrame(() => {
        hoverResetFrame = null;
        const activeRadio = productForm.querySelector('input[type="radio"][name="id"]:checked') || singleHiddenInput;
        const activeTitle = activeRadio
          ? activeRadio.dataset.variantTitle || activeRadio.getAttribute('aria-label') || ''
          : '';
        setVariantLabel(activeTitle);
      });
    });
  });

  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', () => {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
  }

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', () => {
      const current = parseInt(qtyInput.value, 10);
      if (current > 1) qtyInput.value = current - 1;
    });
  }

  /* ── AJAX add to cart → open drawer ─────────────────────── */
  productForm.addEventListener('submit', (e) => {
    e.preventDefault();

    const hasRadioInputs = productForm.querySelectorAll('input[type="radio"][name="id"]').length > 0;
    const selectedVariant = hasRadioInputs
      ? productForm.querySelector('input[type="radio"][name="id"]:checked')
      : productForm.querySelector('input[name="id"]');

    const errorMsg = productForm.querySelector('.js-size-error-message');

    if (!selectedVariant || !selectedVariant.value) {
      if (errorMsg) errorMsg.style.display = 'block';
      return;
    }
    if (errorMsg) errorMsg.style.display = 'none';

    const variantId = selectedVariant.value;
    const quantity  = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    if (addToCartBtn) addToCartBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(response => {
        if (!response.ok) return response.json().then(d => { throw d; });
        return response.json();
      })
      .then(() => {
        if (typeof load_cart === 'function') {
          load_cart().then(() => {
            if (typeof openCartDrawer === 'function') openCartDrawer();
          });
        } else {
          if (typeof openCartDrawer === 'function') openCartDrawer();
        }
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        if (err && err.description) {
          alert(err.description);
        }
      })
      .finally(() => {
        if (addToCartBtn) addToCartBtn.disabled = false;
      });
  });
}

function initProductAccordions() {
  const accordionItems = document.querySelectorAll('.section-product .product-accordion-item');
  accordionItems.forEach(item => {
    const btn = item.querySelector('.product-accordion-btn');
    if (!btn || btn.hasAttribute('data-accordion-bound')) return;
    btn.setAttribute('data-accordion-bound', 'true');

    btn.addEventListener('click', function() {
      const isOpen = item.classList.contains('is-open');

      accordionItems.forEach(i => {
        i.classList.remove('is-open');
        const b = i.querySelector('.product-accordion-btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function initCountdown() {
  const el = document.querySelector('.product-countdown[data-end-datetime]');
  if (!el || el.dataset.countdownInitialized === 'true') return;
  el.dataset.countdownInitialized = 'true';

  const endTime = new Date(el.dataset.endDatetime).getTime();
  if (isNaN(endTime)) return;

  const daysEl = el.querySelector('.js-countdown-days');
  const hoursEl = el.querySelector('.js-countdown-hours');
  const minutesEl = el.querySelector('.js-countdown-minutes');
  const secondsEl = el.querySelector('.js-countdown-seconds');

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  let timerId;

  function tick() {
    const diff = endTime - Date.now();

    if (diff <= 0) {
      el.classList.add('is-expired');
      if (timerId) clearInterval(timerId);
      return;
    }

    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);
  }

  tick();
  timerId = setInterval(tick, 1000);
}

function initGiftCardForm() {
  const checkbox = document.querySelector('.js-gift-card-checkbox');
  const fieldsWrapper = document.querySelector('.js-gift-card-fields');
  
  if (checkbox && fieldsWrapper) {
    const inputs = fieldsWrapper.querySelectorAll('input, textarea');
    checkbox.addEventListener('change', function() {
      if (this.checked) {
        fieldsWrapper.classList.add('is-visible');
        inputs.forEach(input => input.disabled = false);
      } else {
        fieldsWrapper.classList.remove('is-visible');
        inputs.forEach(input => input.disabled = true);
      }
    });
  }
}

function syncWishlistButtonText(container) {
  var wrapper = container.querySelector('.product-wishlist-wrapper');
  if (!wrapper) return;

  var textEl = wrapper.querySelector('.product-wishlist-text');
  if (!textEl) return;

  var isSelected = wrapper.classList.contains('wk-selected');
  var text = isSelected ? container.dataset.wishlistAddedText : container.dataset.wishlistAddText;

  if (text && textEl.textContent !== text) {
    textEl.textContent = text;
  }
}

function initWishlistButtonTextSync() {
  var containers = document.querySelectorAll('.product-wishlist-reward-points');

  containers.forEach(function (container) {
    if (container.wishlistTextObserver) return;

    syncWishlistButtonText(container);

    var observer = new MutationObserver(function () {
      syncWishlistButtonText(container);
    });

    observer.observe(container, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
      childList: true
    });

    container.wishlistTextObserver = observer;
  });
}

function initProductAll() {
  initProductGallery();
  initProductForm();
  initProductAccordions();
  initCountdown();
  initGiftCardForm();
  initWishlistButtonTextSync();
}

document.addEventListener('DOMContentLoaded', initProductAll);
window.addEventListener('load', initProductAll);
document.addEventListener('shopify:section:load', initProductAll);

/* ── Upsell add to cart ─────────────────────────────────────────
   Handled by the delegated `.js-upsell-add-to-cart` listener in
   cart-drawer.js, which serves the drawer's upsell cards and this block
   alike. Binding a second document-level listener here made the two race:
   cart-drawer.js disabled the button first, so this one bailed on the
   `disabled` guard and the drawer never opened. */

/**
 * Sticky Add to Cart bar (PDP only).
 *
 * The variant dropdown / shade dots inside `.sticky-add-to-cart` reuse the
 * exact markup + data-attributes of the Product Card `grid-meta` selector,
 * so the delegated click handling already registered in theme.js (bound on
 * `document`, scoped via `.closest('.snippet-product-card')`) drives them
 * with no changes to that file. This script only adds what theme.js can't
 * already do for a PDP context: show/hide on scroll, the "scroll to the
 * real form" button, and keeping the bar's variant in sync with the main
 * product form so the eventual Add to Cart submit uses the right variant.
 */
(function () {
  function getStickyCard() {
    return document.querySelector('.sticky-add-to-cart .snippet-product-card');
  }

  function getStickyVariants(card) {
    if (card._stickyVariants) return card._stickyVariants;
    var node = card.querySelector('.js-card-variant-data');
    var data = [];
    if (node) {
      try {
        data = JSON.parse(node.textContent) || [];
      } catch (e) {
        console.error('Sticky ATC variant data parse error:', e);
      }
    }
    card._stickyVariants = data;
    return data;
  }

  function findStickyVariantById(card, id) {
    var variants = getStickyVariants(card);
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return null;
  }

  function setVariantNameLabel(card, variant) {
    var label = card.querySelector('.js-sticky-variant-name');
    if (label && variant && variant.title) label.textContent = variant.title;
  }

  /* Button stays clickable either way (it only scrolls to the real form) —
     this just swaps its label to reflect the selected variant's own
     `available` flag, already present on the variant data, not a new check. */
  function setAddToCartLabel(card, variant) {
    var bar = card.closest('.sticky-add-to-cart');
    var btn = bar && bar.querySelector('.js-sticky-scroll-to-form');
    if (!btn || !variant) return;

    var comingSoon = btn.dataset.comingSoon === 'true';
    var notifyEnabled = btn.dataset.notifyEnabled === 'true';
    var soldOut = !variant.available;
    var showNotify = notifyEnabled && (comingSoon || soldOut);

    btn.textContent = comingSoon || soldOut ? btn.dataset.soldOutText : btn.dataset.addToCartText;
    btn.classList.toggle('is-sold-out', soldOut && !showNotify);
    btn.classList.toggle('js-klaviyo-bis', showNotify);
    btn.classList.toggle('sticky-add-to-cart__btn--notify', showNotify && !comingSoon);
  }

  /* ── Show / hide on scroll ──────────────────────────────────── */
  /* Visible whenever the on-page form is out of view — except while the
     footer is in view, where it hides regardless of the form's position. */

  function initVisibility() {
    var bar = document.querySelector('.sticky-add-to-cart');
    var target = document.querySelector('.product-form__actions');
    var footer = document.querySelector('.section-footer');
    if (!bar || !target || bar.dataset.visibilityInitialized === 'true') return;
    bar.dataset.visibilityInitialized = 'true';

    var formOutOfView = false;
    var footerInView = false;

    function render() {
      bar.classList.toggle('is-visible', formOutOfView && !footerInView);
    }

    var formObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        formOutOfView = !entry.isIntersecting;
      });
      render();
    }, { threshold: 0 });
    formObserver.observe(target);

    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          footerInView = entry.isIntersecting;
        });
        render();
      }, { threshold: 0 });
      footerObserver.observe(footer);
    }
  }

  /* ── Mobile-only: duplicated product info row inside the bar ──
     `.sticky-add-to-cart__product` (image/title/price/variant) is a
     separate concern from the bar's own visibility above: the bar itself
     stays tied to `.product-form__actions` on every breakpoint. On mobile,
     the duplicated row is a simple viewport check against three elements
     (media, title/price, variant swatches):
       - all three in view  -> hide the duplicated row
       - any one out of view -> show the duplicated row
     `.sticky-add-to-cart__actions` (button + notice) is untouched and
     always stays visible whenever the bar is.

     `.product-form__group.variant-swatches` only exists in the DOM for
     products that actually have variants (see snippets/variant-picker.liquid
     — it's wrapped in `{% if show_swatches_block %}`), so it's simply
     skipped for products without variants rather than treated as "always
     out of view", which would otherwise permanently show the row on those
     products. */

  function initProductRowVisibility() {
    var productRow = document.querySelector('.sticky-add-to-cart__product');
    var targets = [
      document.querySelector('.product-media-wrapper'),
      document.querySelector('.product-title-price-row'),
      document.querySelector('.product-form__group.variant-swatches')
    ].filter(Boolean);
    if (!productRow || !targets.length || productRow.dataset.visibilityInitialized === 'true') return;
    productRow.dataset.visibilityInitialized = 'true';

    var mobileQuery = window.matchMedia('(max-width: 991px)');
    var inViewState = targets.map(function () { return true; });

    function allTargetsInView() {
      return inViewState.indexOf(false) === -1;
    }

    function render() {
      // Desktop is untouched: only ever apply the hidden state on mobile.
      var shouldHide = mobileQuery.matches && allTargetsInView();
      productRow.classList.toggle('is-hidden-in-sticky', shouldHide);
    }

    var productAreaObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var index = targets.indexOf(entry.target);
        if (index !== -1) inViewState[index] = entry.isIntersecting;
      });
      render();
    }, { threshold: 0 });

    targets.forEach(function (target) {
      productAreaObserver.observe(target);
    });

    // Re-evaluate immediately on breakpoint changes (resize/rotate) so
    // switching to desktop always clears any hidden state left from mobile.
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', render);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(render);
    }
  }

  /* ── Contextual Sticky Add to Cart Handler ──────────────────── */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-sticky-scroll-to-form');
    if (!btn || btn.disabled || btn.classList.contains('is-disabled') || btn.classList.contains('is-sold-out')) return;
    if (btn.classList.contains('js-klaviyo-bis')) return;
    e.preventDefault();

    var productForm = document.querySelector('.product-form-snippet form');
    var card = getStickyCard();

    // Check if variant radio is checked in main form, or if product has only single variant
    var checkedRadio = productForm ? productForm.querySelector('input[type="radio"][name="id"]:checked') : null;
    var singleInput = (productForm && productForm.querySelectorAll('input[type="radio"][name="id"]').length === 0) ? productForm.querySelector('input[name="id"]') : null;
    var selectedVariantInput = checkedRadio || singleInput;

    var selectedVariantId = selectedVariantInput ? selectedVariantInput.value : (card && card.dataset.activeVariantId ? card.dataset.activeVariantId : null);

    // If no size/variant is selected: show error message and scroll up to size picker / form
    if (!selectedVariantId) {
      if (productForm) {
        var errorMsg = productForm.querySelector('.js-size-error-message');
        if (errorMsg) errorMsg.style.display = 'block';
      }
      var target = document.querySelector(btn.dataset.scrollTarget || '.product-form__actions');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // Hide error message if present
    if (productForm) {
      var errorMsg = productForm.querySelector('.js-size-error-message');
      if (errorMsg) errorMsg.style.display = 'none';
    }

    var qtyInput = productForm ? productForm.querySelector('#quantity') : null;
    var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    btn.disabled = true;

    var payload = { id: selectedVariantId, quantity: quantity };
    var sellingPlanInput = productForm ? productForm.querySelector('input[name="selling_plan"]:checked, select[name="selling_plan"]') : null;
    if (sellingPlanInput && sellingPlanInput.value) {
      payload.selling_plan = sellingPlanInput.value;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) { throw err; });
        }
        return response.json();
      })
      .then(function () {
        if (typeof load_cart === 'function') {
          load_cart().then(function () {
            if (typeof openCartDrawer === 'function') openCartDrawer();
          });
        } else if (typeof openCartDrawer === 'function') {
          openCartDrawer();
        }
      })
      .catch(function (err) {
        console.error('Sticky add to cart error:', err);
        if (err && err.description) {
          alert(err.description);
        }
      })
      .finally(function () {
        btn.disabled = false;
      });
  });

  /* ── Sticky bar → main form: keep the real Add to Cart in sync ──
     theme.js's delegated listener (registered earlier, since theme.js
     loads before this file) already updated the sticky card's own
     price/image/shade state by the time this runs, so we just read the
     resulting variant id and mirror it onto the on-page form. */

  document.addEventListener('click', function (e) {
    var withinSticky = e.target.closest('.sticky-add-to-cart');
    if (!withinSticky) return;
    if (!e.target.closest('.js-shade-dot') && !e.target.closest('.js-size-option')) return;

    var card = getStickyCard();
    if (!card) return;

    var variantId = card.dataset.activeVariantId;
    var variant = findStickyVariantById(card, variantId);
    setVariantNameLabel(card, variant);
    setAddToCartLabel(card, variant);

    var radio = document.querySelector('.product-form-snippet input[name="id"][value="' + variantId + '"]');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ── Main form → sticky bar: mirror the visual state only ────── */

  window.syncStickyAddToCartVariant = function (variantId) {
    var card = getStickyCard();
    if (!card) return;

    var variant = findStickyVariantById(card, variantId);
    if (!variant) return;

    if (String(card.dataset.activeVariantId) === String(variant.id)) return;
    card.dataset.activeVariantId = variant.id;
    card._selectedOptions = variant.options ? variant.options.slice() : [];

    var priceEl = card.querySelector('.js-card-price');
    if (priceEl && variant.price) priceEl.innerHTML = variant.price;

    setVariantNameLabel(card, variant);
    setAddToCartLabel(card, variant);

    var sizeIndex = parseInt(card.dataset.sizeOptionIndex, 10);
    var sizeValue = sizeIndex > -1 && variant.options ? variant.options[sizeIndex] : null;
    if (sizeValue) {
      var labelEl = card.querySelector('.js-selected-size-label');
      if (labelEl) labelEl.textContent = sizeValue;

      card.querySelectorAll('.js-size-option').forEach(function (opt) {
        var isSelected = opt.dataset.sizeValue === sizeValue;
        opt.classList.toggle('is-selected', isSelected);
        opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
    }

    card.querySelectorAll('.js-shade-dot').forEach(function (dot) {
      dot.classList.toggle('is-active', dot.dataset.variantId === String(variant.id));
    });

    var mainImg = card.querySelector('.sticky-add-to-cart__media .main-image');
    if (mainImg && variant.image) mainImg.src = variant.image;
  };

  /* ── Init ───────────────────────────────────────────────────── */

  function init() {
    initVisibility();
    initProductRowVisibility();
    alignVariantTextListWidths();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', function () {
    init();
    alignVariantTextListWidths();
  });
  window.addEventListener('resize', alignVariantTextListWidths);
})();
